import moment from "moment";

export default function(dateString, endFormat = "DD-MM-YYYY HH:mm") {
  var date = moment(dateString, "YYYY-MM-DD HH:mm:ss");

  return date.format(endFormat);
}
